export function BrandBadges() {
  return (
    <div className="bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap justify-center items-center gap-8">
          <a href="https://fazier.com/launches/www.chinese-name.net" target="_blank" rel="noopener noreferrer">
            <img src="https://fazier.com/api/v1//public/badges/launch_badges.svg?badge_type=launched&theme=light" width={120} alt="Fazier badge" />
          </a>
          
          <a href="https://turbo0.com/item/chinese-name-generator" target="_blank" rel="noopener noreferrer">
            <img src="https://img.turbo0.com/badge-listed-light.svg" alt="Listed on Turbo0" style={{ height: '54px', width: 'auto' }} />
          </a>
          
          <a href="https://startupfa.me/s/chinese-namenet?utm_source=www.chinese-name.net" target="_blank" rel="noopener noreferrer">
            <img src="https://startupfa.me/badges/featured-badge-small.webp" alt="Chinese Name - Featured on Startup Fame" width={224} height={36} />
          </a>
          
          <a href="https://twelve.tools" target="_blank" rel="noopener noreferrer">
            <img src="https://twelve.tools/badge0-white.svg" alt="Featured on Twelve Tools" width={200} height={54} />
          </a>
          
          <a href="https://finetools.ai/" title="Finetools AI Tools Directory">Finetools AI Tools Directory</a>
          
          <a href="https://dang.ai/" target="_blank" rel="noopener noreferrer">
            <img src="https://cdn.prod.website-files.com/63d8afd87da01fb58ea3fbcb/6487e2868c6c8f93b4828827_dang-badge.png" alt="Dang.ai" style={{ width: '150px', height: '54px' }} width="150" height="54" />
          </a>
        </div>
      </div>
    </div>
  );
}

